export default __webpack_public_path__ + "static/media/WaspGreen.f7be32fd.svg";